import { QueryClient } from '@tanstack/react-query'

// Global query client instance - exported so it can be used for cache clearing on logout
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Clear all cached data (call this on logout)
export function clearQueryCache() {
  queryClient.clear()
}
